// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"gS-z","categoryName":"hS-z","categoryNameSearchHeader":"iS-z","categoryContent":"jS-z","bottomAligned":"kS-z","image":"lS-z","imageNoBackground":"mS-z"};